import { BookingChangeRelocationDialog } from "@/app/Bookings/Components/BookingChangeRelocationDialog";
import { useBooking } from "@/app/Bookings/Hooks/useBooking";

/**
 * Loads the full booking record the dialog needs, so the call list only pays
 * for it when a rep moves the customer onto the deal that matched.
 */
export function CallbackLeadChangeRelocationDialog({
  bookingId,
  relocationId,
}: {
  bookingId: string;
  relocationId: string;
}) {
  const booking = useBooking(bookingId);

  return (
    <BookingChangeRelocationDialog
      booking={booking}
      newRelocation={{ id: relocationId }}
    />
  );
}
